import firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDiJMnd2GXm3rxxhUN0Rbfl2GFJr-pS4bc',
  authDomain: 'console.matkortet.com',
  databaseURL: 'https://matkortet-58620.firebaseio.com',
  projectId: 'matkortet-58620',
  storageBucket: 'matkortet-58620.appspot.com',
  messagingSenderId: '608924600621',
  appId: '1:608924600621:web:cd960ad474320d5e20aba4',
  measurementId: 'G-6S11186DE1',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// NOTE: this is redundant, don't use it, but the linter was
// being a bitch about exports so i had to do this to avoid breaking code in other files.
const fbAuth = firebase.auth();

export { firebase, fbAuth };
